import { ChainedMap } from "./utils/index.js";

export class Output extends ChainedMap {
  constructor(parent) {
    super(parent);
    this.extend([
      "assetModuleFilename",
      "asyncChunks",
      "auxiliaryComment",
      "charset",
      "chunkFilename",
      "chunkFormat",
      "chunkLoadTimeout",
      "chunkLoadingGlobal",
      "chunkLoading",
      "clean",
      "compareBeforeEmit",
      "crossOriginLoading",
      "cssChunkFilename",
      "cssFilename",
      "devtoolFallbackModuleFilenameTemplate",
      "devtoolModuleFilenameTemplate",
      "devtoolNamespace",
      "enabledChunkLoadingTypes",
      "enabledLibraryTypes",
      "enabledWasmLoadingTypes",
      "environment",
      "filename",
      "globalObject",
      "hashDigest",
      "hashDigestLength",
      "hashFunction",
      "hashSalt",
      "hotUpdateChunkFilename",
      "hotUpdateGlobal",
      "hotUpdateMainFilename",
      "iife",
      "ignoreBrowserWarnings",
      "importFunctionName",
      "importMetaName",
      "library",
      "libraryExport",
      "libraryTarget",
      "module",
      "path",
      "pathinfo",
      "publicPath",
      "scriptType",
      "sourceMapFilename",
      "sourcePrefix",
      "strictModuleErrorHandling",
      "strictModuleExceptionHandling",
      "trustedTypes",
      "umdNamedDefine",
      "uniqueName",
      "wasmLoading",
      "webassemblyModuleFilename",
      "workerChunkLoading",
      "workerPublicPath",
      "workerWasmLoading",
    ]);
  }
}
